import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./returnaudit.css";

function Returnaudit() {
  const [data, setData] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState("");
  const [distributors, setDistributors] = useState([]);
  const [skuSearch, setSkuSearch] = useState("");
  const [totalReturnQuantity, setTotalReturnQuantity] = useState(0);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`).then(
      (response) => {
        setData(response.data);

        const uniqueDistributors = [
          ...new Set(response.data.map((item) => item.Distributor)),
        ];
        setDistributors(uniqueDistributors);
      }
    );
  }, []);

  const filteredData = selectedDistributor
    ? data.filter((item) => item.Distributor === selectedDistributor)
    : [];

  const skuFilteredData = skuSearch
    ? filteredData
        .map((item) => ({
          ...item,
          Entries: item.Entries.filter(
            (entry) =>
              entry.SKU.toLowerCase().includes(skuSearch.toLowerCase()) ||
              entry.Title.toLowerCase().includes(skuSearch.toLowerCase())
          ),
        }))
        .filter((item) => item.Entries.length > 0)
    : filteredData;

  useEffect(() => {
    let total = 0;

    if (skuSearch) {
      total = filteredData.reduce((sum, item) => {
        const entryTotal = item.Entries.filter(
          (entry) =>
            entry.SKU.toLowerCase().includes(skuSearch.toLowerCase()) ||
            entry.Title.toLowerCase().includes(skuSearch.toLowerCase())
        ).reduce((entrySum, entry) => entrySum + entry.Return_Quantity, 0);
        return sum + entryTotal;
      }, 0);
    } else if (selectedDistributor) {
      total = filteredData.reduce((sum, item) => {
        const entryTotal = item.Entries.reduce(
          (entrySum, entry) => entrySum + entry.Return_Quantity,
          0
        );
        return sum + entryTotal;
      }, 0);
    }

    setTotalReturnQuantity(total);
  }, [skuSearch, selectedDistributor, filteredData]);
  

  return (
    <div className="returnaudit-container">
      <label style={{ textAlign: "center" }}>Return Audit</label>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "40px",
          marginBottom: "20px",
          flexWrap: "nowrap",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <label
            style={{
              fontWeight: "bold",
              whiteSpace: "nowrap",
              margin: 0,
              lineHeight: "1.5",
            }}
          >
            Select Distributor:
          </label>
          <select
            value={selectedDistributor}
            onChange={(e) => {
              setSelectedDistributor(e.target.value);
              setSkuSearch("");
            }}
            style={{
              padding: "8px 12px",
              fontSize: "14px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              minWidth: "200px",
              height: "40px",
            }}
          >
            <option value="">-- Select Distributor --</option>
            {distributors.map((distributor, index) => (
              <option key={index} value={distributor}>
                {distributor}
              </option>
            ))}
          </select>
        </div>

        {selectedDistributor && (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label
              style={{
                fontWeight: "bold",
                whiteSpace: "nowrap",
                margin: 0,
                lineHeight: "1.5",
              }}
            >
              Search SKU:
            </label>
            <input
              type="text"
              placeholder="Enter sku or title"
              value={skuSearch}
              onChange={(e) => setSkuSearch(e.target.value)}
              style={{
                padding: "8px 12px",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                minWidth: "200px",
                height: "40px",
              }}
            />
          </div>
        )}
      </div>

      {selectedDistributor && (
        <div
          style={{
            fontWeight: "bold",
            color: "green",
            whiteSpace: "nowrap",
            lineHeight: "40px",
            height: "40px",
            marginBottom: "10px",
            backgroundColor: "#e6ffe6",
            padding: "0 12px",
            borderRadius: "4px",
            display: "inline-block",
          }}
        >
          {skuSearch
            ? `Total Return Quantity for "${skuSearch}": ${totalReturnQuantity}`
            : `Total Return Quantity: ${totalReturnQuantity}`}
        </div>
      )}

      {selectedDistributor && (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>GRN No</th>
                <th>Distributor</th>
                <th>Invoice No</th>
                <th>Date</th>
                <th>Discount Value</th>
                <th>Return Value</th>
                <th>SKU</th>
                <th>Title</th>
                <th>Edition</th>
                <th>Medium</th>
                <th>MRP</th>
                <th>HSN Code</th>
                <th>Return Quantity</th>
                <th>Good Quantity</th>
                <th>Bad Quantity</th>
              </tr>
            </thead>
            <tbody>
              {skuFilteredData.map((item, index) =>
                item.Entries.map((entry, subIndex) => (
                  <tr key={`${index}-${subIndex}`}>
                    <td>{item.OrderSeq}</td>
                    <td>{item.Distributor}</td>
                    <td>{item.Invoice_Number}</td>
                    <td>{item.Date}</td>
                    <td>{entry.discount}</td>
                    <td>{item.totalAmountValue}</td>
                    <td>{entry.SKU}</td>
                    <td>{entry.Title}</td>
                    <td>{entry.Edition}</td>
                    <td>{entry.Medium}</td>
                    <td>{entry.mrp}</td>
                    <td>{entry.HSNCode}</td>
                    <td>{entry.Return_Quantity}</td>
                    <td>{entry.Good_Quantity}</td>
                    <td>{entry.Bad_Quantity}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Returnaudit;
